import { Component, OnInit } from '@angular/core';

import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;
@Component({
  selector: 'app-national-federation',
  templateUrl: './national-federation.component.html',
  styleUrls: ['./national-federation.component.scss']
})
export class NationalFederationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
    ngAfterViewInit(){
      /*---------------------------
      :: lightBox Gallery
      -----------------------------*/
      let galerias = document.getElementsByClassName('video-gallery');
      for (let i = 0; i < galerias.length; i++) {
        galerias[i].id = 'gal' + i; 
        lightGallery(document.getElementById('gal' + i), {
          selector: 'a',
        });
      } 
      
      let gall_image = document.getElementsByClassName('lightgallery');
      for (const gal of gall_image) {
        lightGallery(gal), {
          selector: 'a',
        }
      }
  
  }
    
}